export default __webpack_public_path__ + "static/media/careteam_sidemenu_patient_records.9c5018a9.svg";